import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";

const ViewParent = () => {
  const { id } = useParams(); // Get parentID from URL params
  const navigate = useNavigate();
  const [parent, setParent] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchParentDetails = async () => {
      try {
        const response = await axios.get(` ${process.env.REACT_APP_API_BASE_URL}/api/parents/getParentById/${id}`);
        setParent(response.data);
      } catch (error) {
        console.error("Error fetching parent details", error);
      } finally {
        setLoading(false);
      }
    };

    fetchParentDetails();
  }, [id]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-full bg-gray-100">
        <div className="text-2xl font-semibold text-gray-700">Loading...</div>
      </div>
    );
  }

  if (!parent) {
    return (
      <div className="flex justify-center items-center min-h-full bg-gray-100">
        <div className="text-xl font-semibold text-gray-700">No parent data found.</div>
      </div>
    );
  }
  const handleChildClick = (childId) => {
    navigate(`/students/${childId}`);
  };

  return (
    <div className="min-h-full p-6">
      <div className="max-w-6xl mx-auto bg-white rounded-xl shadow-xl p-8">
        <h1 className="text-4xl font-bold text-gray-900 text-center mb-10 tracking-wide">
          Parent Profile
        </h1>

        {/* Parent Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-6">
          {/* Father Section */}
          <div className="bg-gradient-to-tr from-blue-50 to-blue-100 p-6 rounded-lg shadow-lg text-center">
            <div className="w-36 h-36 rounded-xl bg-blue-200 p-2 mx-auto mb-4">
              <img
                src={parent.fatherImage || "https://via.placeholder.com/150"}
                alt="Father"
                className="w-full h-full rounded-xl object-cover"
              />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800">{parent.fatherName}</h2>
            <p className="text-gray-600 mt-2">DOB: {new Date(parent.fatherDOB).toLocaleDateString()}</p>
            <p className="text-gray-600">Age: {parent.fatherAge || "N/A"}</p>
          </div>

          {/* Mother Section */}
          <div className="bg-gradient-to-tr from-pink-50 to-pink-100 p-6 rounded-lg shadow-lg text-center">
            <div className="w-36 h-36 rounded-xl bg-pink-200 p-2 mx-auto mb-4">
              <img
                src={parent.motherImage || "https://via.placeholder.com/150"}
                alt="Mother"
                className="w-full h-full rounded-xl object-cover"
              />
            </div>
            <h2 className="text-2xl font-semibold text-gray-800">{parent.motherName}</h2>
            <p className="text-gray-600 mt-2">DOB: {new Date(parent.motherDOB).toLocaleDateString()}</p>
            <p className="text-gray-600">Age: {parent.motherAge || "N/A"}</p>
          </div>
        </div>

        {/* Anniversary Information */}
        <div className="bg-gray-50 p-6 rounded-lg shadow-lg text-center mb-6">
          <p className="text-lg font-medium text-gray-700">
            <span className="text-indigo-600">Anniversary:</span> {parent.anniversary || "N/A"}
          </p>
        </div>
        
        <div className="bg-gray-50 p-6 rounded-lg shadow-lg text-center mb-6">
  <p className="text-lg font-medium text-gray-700 flex items-center justify-around gap-8">
    <span className="flex items-center gap-2">
      <i className="fas fa-phone"></i> <span className="text-indigo-600">Phone No:</span> {parent.phoneNo || "N/A"}
    </span>
    <span className="flex items-center gap-2">
      <i className="fas fa-phone"></i> <span className="text-indigo-600">Phone No2:</span> {parent.phoneNo2 || "N/A"}
    </span>
  </p>
</div>


        {/* Children Section */}
        <div className="bg-gradient-to-tr from-green-50 to-green-100 p-6 rounded-lg shadow-lg">
          <h3 className="text-2xl font-semibold text-gray-800 mb-6 text-center">Children</h3>
          {parent.children.length > 0 ? (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {parent.children.map((child, index) => (
                <div
                  key={index}
                  onClick={() => handleChildClick(child._id)}
                  className="bg-white rounded-lg shadow-md p-4 text-center transform transition-transform duration-300 hover:scale-105"
                >
                  <h4 className="text-xl font-semibold text-gray-700">{child.firstName || "N/A"} {child.lastName || "N/A"}</h4>
                  {/* <p className="text-gray-500 mt-1">Class: {child.class || "N/A"} ({child.section || "N/A"})</p> */}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-lg text-gray-600 text-center">No children details available.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewParent;
